// Rules
import Vue from 'vue'
import axios from 'axios'
import orderTools from "@/V2/helpers/orderTools";
import { getSessionToken } from '@shopify/app-bridge-utils';

export default {
	namespaced: true,
	state: {
        rules: {
            domestic: {
                cheapest: true,
                keywords: [],
                default: {
                    carrier: null,
                    service: null
                }
            },
            international: {
                cheapest: true,
                keywords: [],
                default: {
                    carrier: null,
                    service: []
                }
            },
        },

	},
	mutations: {
        init: function (state, payload) {
			Object.keys(payload).forEach( (type) => {
                Object.keys(payload[type]).forEach( (rule) => {
                    Vue.set(state.rules[type], rule, payload[type][rule])
                })
            }) 
        }
	},
	getters: {
		all: state => {
			return state.rules
        },
		domestic: state => {
			return state.rules.domestic
        },
		international: state => {
			return state.rules.international
        },
	},
	actions: {
		save: async function({ state, rootGetters }) {
			const token = await getSessionToken(rootGetters['Shopify/app']);
			return axios.post(`${process.env.VUE_APP_V2_SHOPIFY_API}/rules/save`, { rules: state.rules },
			{
				headers: { 
					'Authorization': token,
				}
			})
			.then(response => {
				orderTools.log([{
					id: 'Rules',
					type: 'Save',
					data: { rules: state.rules, response: response.data }
				}])
			})
			.catch(err => {
				orderTools.log_error({message: 'Network Error', stack: 'rules/save', data: err})
			})

		},
		async list({ commit, dispatch, rootGetters }) {
			/**
			 * Inject BE?PM0 “XS satchel” codes at most once
			 * per keyword/default block in domestic rules.
			 */
			const addXsSatchel = (rulesObj) => {
			  const domestic = rulesObj?.domestic;
			  if (!domestic) return rulesObj;              // nothing to patch
	  
			  // helper to add the XS code if not already present
			  const maybeAdd = (target, normal, xs) => {
				if (
				  Array.isArray(target?.service) &&
				  target.service.includes(normal) &&
				  !target.service.includes(xs) &&
				  !target.xs_set
				) {
				  target.service.push(xs);
				  target.xs_set = true;
				}
			  };
	  
			  // 1) iterate keyword blocks
			  (domestic.keywords || []).forEach((kw) => {
				maybeAdd(kw, 'BE9P05', 'BE9PM0');
				maybeAdd(kw, 'BE1P05', 'BE1PM0');
			  });
	  
			  // 2) default block
			  if (domestic.default) {
				maybeAdd(domestic.default, 'BE9P05', 'BE9PM0');
				maybeAdd(domestic.default, 'BE1P05', 'BE1PM0');
			  }
	  
			  return rulesObj;
			};
	  
			try {
			  const token = await getSessionToken(rootGetters['Shopify/app']);
	  
			  const { data } = await axios.post(
				`${process.env.VUE_APP_V2_SHOPIFY_API}/rules/list`,
				{},
				{ headers: { Authorization: token } }
			  );
	  
			  if (data?.rules) {
				const patchedRules = addXsSatchel(data.rules.rules); // pass ONLY .rules
				commit('init', patchedRules);
				dispatch('save')
			  }
	  
			  return data;          // action result
			} catch (err) {
			  orderTools.log_error({
				message: 'Network Error',
				stack:   'rules/list',
				data:    err,
			  });
			  throw err;
			}
		  },
        init: async function ({ dispatch }) {
            await dispatch('list')
			return true
        },
	},
	modules: {
	}
}
